import { Component } from '@angular/core';
import { ChartLineConfig, ChartLineComponent } from "../../../ia/chart-components/chart-line/chart-line.component";
import { ChartLineMultipleComponent } from "../../../ia/chart-components/chart-line/chart-line-multiple.component";
import { ChartBarComponent, ChartBarConfig } from "../../../ia/chart-components/chart-bar/chart-bar.component";
import { ChartBarStackedComponent } from "../../../ia/chart-components/chart-bar/chart-bar-stacked.component";
import { ChartBarMultipleComponent } from "../../../ia/chart-components/chart-bar/chart-bar-multiple.component";
import { ChartDonutComponent, ChartDonutConfig } from "../../../ia/chart-components/chart-donut/chart-donut.component";
import { ChartDonutGroupComponent, ChartDonutGroupConfig } from "../../../ia/chart-components/chart-donut/chart-donut-group.component";

@Component({
  selector: 'app-ai-charts-uikit',
  standalone: true,
  imports: [ChartLineComponent, ChartLineMultipleComponent, ChartBarComponent, ChartBarStackedComponent, ChartBarMultipleComponent, ChartDonutComponent, ChartDonutGroupComponent],
  templateUrl: './ai-charts-uikit.component.html',
  styleUrls: ['./ai-charts-uikit.component.scss']
})
export class AiChartsUikitComponent {

  //#region ChartLine — series estáticas
  lineTitle = 'ChartLine — series estáticas';
  lineSub = 'Se declaran categoryField + series de antemano';

  lineConfig: ChartLineConfig = {
    categoryField: 'mes',
    series: [
      { field: 'real', name: 'Real', color: '#00e676', dashed: false },
      { field: 'meta', name: 'Meta', color: '#ffb020', dashed: true },
    ],
  };

  lineData = [
    { mes: 'Ene', real: 1.1, meta: 1.4 },
    { mes: 'Feb', real: 2.1, meta: 2.8 },
    { mes: 'Mar', real: 3.2, meta: 4.2 },
    { mes: 'Abr', real: 4.6, meta: 5.6 },
    { mes: 'May', real: null, meta: 7.0 },
    { mes: 'Jun', real: null, meta: 8.3 },
  ];
  //#endregion ChartLine — series estáticas

  //#region ChartLine — groupBy
  groupByTitle = 'ChartLine — groupBy';
  groupBySub = 'Series dinámicas — se generan a partir de los valores únicos de un campo';

  groupByConfig: ChartLineConfig = {
    categoryField: 'fecha',
    groupBy: { key: 'dependencia_nombre', valueField: 'recibidos' },
  };

  groupByData = [
    { dependencia_nombre: 'OFICINA DE PENSIONES', fecha: 'Oct 2025', recibidos: 2 },
    { dependencia_nombre: 'OFICINA DE PENSIONES', fecha: 'Nov 2025', recibidos: 5 },
    { dependencia_nombre: 'OFICINA DE PENSIONES', fecha: 'Dic 2025', recibidos: 9 },
    { dependencia_nombre: 'OFICINA DE TALENTO HUMANO', fecha: 'Oct 2025', recibidos: 1 },
    { dependencia_nombre: 'OFICINA DE TALENTO HUMANO', fecha: 'Nov 2025', recibidos: 3 },
    { dependencia_nombre: 'OFICINA DE TALENTO HUMANO', fecha: 'Dic 2025', recibidos: 4 },
    { dependencia_nombre: 'SECRETARÍA DE SALUD', fecha: 'Oct 2025', recibidos: 4 },
    { dependencia_nombre: 'SECRETARÍA DE SALUD', fecha: 'Nov 2025', recibidos: 12 },
    { dependencia_nombre: 'SECRETARÍA DE SALUD', fecha: 'Dic 2025', recibidos: 20 },
  ];
  //#endregion ChartLine — groupBy

  //#region ChartLineMultiple
  multipleTitle = 'ChartLineMultiple — varios charts, misma data';
  multipleSub = 'Un array de configs — cada uno se grafica completo, sin dividir la data';

  multipleConfig: ChartLineConfig[] = [
    { title: 'Recibidos', categoryField: 'fecha', groupBy: { key: 'dependencia_nombre', valueField: 'recibidos' } },
    { title: 'Variación %', categoryField: 'fecha', groupBy: { key: 'dependencia_nombre', valueField: 'variacion_porcentual' } },
  ];

  multipleData = [
    { dependencia_nombre: 'OFICINA DE PENSIONES', fecha: 'Oct 2025', recibidos: 2, variacion_porcentual: 0 },
    { dependencia_nombre: 'OFICINA DE PENSIONES', fecha: 'Nov 2025', recibidos: 5, variacion_porcentual: 150 },
    { dependencia_nombre: 'OFICINA DE PENSIONES', fecha: 'Dic 2025', recibidos: 9, variacion_porcentual: 80 },
    { dependencia_nombre: 'OFICINA DE TALENTO HUMANO', fecha: 'Oct 2025', recibidos: 1, variacion_porcentual: 0 },
    { dependencia_nombre: 'OFICINA DE TALENTO HUMANO', fecha: 'Nov 2025', recibidos: 3, variacion_porcentual: 200 },
    { dependencia_nombre: 'OFICINA DE TALENTO HUMANO', fecha: 'Dic 2025', recibidos: 4, variacion_porcentual: 33 },
  ];
  //#endregion ChartLineMultiple

  //#region ChartBar
  barTitle = 'ChartBar — barras horizontales';
  barSub = 'Se pasan config + data — igual que ChartLine';

  barConfig: ChartBarConfig = {
    categoryField: 'dependencia',
    bars: [
      { field: 'recibidos', name: 'Recibidos' },
    ],
  };

  barData = [
    { dependencia: 'Oficina de Pensiones', recibidos: 12 },
    { dependencia: 'Oficina de Talento Humano', recibidos: 8 },
    { dependencia: 'Secretaría de Educación', recibidos: 54 },
    { dependencia: 'Secretaría de Hacienda', recibidos: 54 },
    { dependencia: 'Secretaría de Salud', recibidos: 3 },
  ];
  //#endregion ChartBar

  //#region ChartBarStacked
  barStackedTitle = 'ChartBarStacked — barras apiladas';
  barStackedSub = 'Cada bars[] se apila dentro de la misma barra por categoría';

  barStackedConfig: ChartBarConfig = {
    categoryField: 'tramite',
    bars: [
      { field: 'finalizados_a_tiempo', name: 'Finalizados a tiempo' },
      { field: 'finalizado_fuera_de_plazo', name: 'Finalizado fuera de plazo' },
      { field: 'pendientes', name: 'Pendientes' },
    ],
  };

  barStackedData = [
    { tramite: 'Certificación de Residencia', finalizados_a_tiempo: 53, finalizado_fuera_de_plazo: 15, pendientes: 9 },
    { tramite: 'Certificado de tiempo de servicio', finalizados_a_tiempo: 26, finalizado_fuera_de_plazo: 10, pendientes: 8 },
  ];
  //#endregion ChartBarStacked

  //#region ChartBarMultiple
  barMultipleTitle = 'ChartBarMultiple — varios charts, misma data';
  barMultipleSub = 'Un array de configs — cada uno se grafica completo, sin dividir la data';

  barMultipleConfig: ChartBarConfig[] = [
    { title: 'Recibidos', categoryField: 'tramite_nombre', groupBy: { key: 'dependencia_nombre', valueField: 'recibidos' } },
    { title: 'Finalizados a tiempo', categoryField: 'tramite_nombre', groupBy: { key: 'dependencia_nombre', valueField: 'finalizados_a_tiempo' } },
  ];

  barMultipleData = [
    { dependencia_nombre: 'OFICINA DE TALENTO HUMANO', tramite_nombre: 'Certificado de tiempo de servicio', recibidos: 14, finalizados_a_tiempo: 14 },
    { dependencia_nombre: 'SECRETARÍA DEL INTERIOR', tramite_nombre: 'Certificación de Residencia', recibidos: 212, finalizados_a_tiempo: 212 },
  ];
  //#endregion ChartBarMultiple

  //#region ChartDonut
  donutTitle = 'ChartDonut — dona';
  donutSub = 'centerLabel/centerSub son opcionales — por defecto muestran el total';

  donutConfig: ChartDonutConfig = {
    categoryField: 'dependencia',
    valueField: 'recibidos',
  };

  donutData = [
    { dependencia: 'Oficina de Pensiones', recibidos: 12 },
    { dependencia: 'Oficina de Talento Humano', recibidos: 8 },
    { dependencia: 'Secretaría de Educación', recibidos: 54 },
    { dependencia: 'Secretaría de Salud', recibidos: 3 },
  ];
  //#endregion ChartDonut

  //#region ChartDonutGroup
  donutGroupTitle = 'ChartDonutGroup — una dona por valor único';
  donutGroupSub = 'Separa en paneles por groupField — cada panel usa fields[] de esa misma fila';

  donutGroupConfig: ChartDonutGroupConfig = {
    groupField: 'tramite_nombre',
    chart: {
      fields: [
        { field: 'pendientes', name: 'Pendientes' },
        { field: 'finalizados_a_tiempo', name: 'Finalizados a tiempo' },
        { field: 'finalizado_fuera_de_plazo', name: 'Finalizado fuera de plazo' },
      ],
    },
  };

  donutGroupData = [
    { tramite_nombre: 'Certificación de Residencia', pendientes: 55, finalizados_a_tiempo: 161, finalizado_fuera_de_plazo: 27 },
    { tramite_nombre: 'Certificado de tiempo de servicio', pendientes: 42, finalizados_a_tiempo: 12, finalizado_fuera_de_plazo: 15 },
  ];
  //#endregion ChartDonutGroup
}
